export default function setlocation(state = {}, action) {
  switch (action.type) {
    case 'SET_LOCATION':
      return action.location_details;
    default:
      return state;
  }
}
